import { cn } from "@/libs/utils";
import Image from "next/image";

interface Props {
  className?: string;
}

export default function MFMHorizontalFill({ className }: Props) {
  return (
    <div className={cn("relative h-[32px] w-[145px]", className)}>
      <Image
        src="/svgs/mfm-horizontal-filled.svg"
        className="absolute object-contain"
        alt="MFM Horizontal Fill"
        fill
      />
    </div>
  );
}
